var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-trackvideo-card__no-video-wrapper"},[_c('div',{staticClass:"mc-trackvideo-card__no-video-content"},[_c('img',{attrs:{"width":"68","src":_vm.isWhitelabel()
          ? _vm.getAsset('secondaryLogo', 'sidebarMinimize')
          : require('@/assets/images/mceasy-large.png')}}),_c('p',[_vm._v(_vm._s(_vm.$t('trackVideo.state.noVideo')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }